import styled, { css } from "styled-components";

// styles
import { convertPxToRem } from "frontend/components/helpers";

// styled-components
export const HeroSizer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const HeroImageStyled = styled.div`
    width: 100%;
    height: 100%;
    position: relative;

    img {
        max-width: 100%;
        max-height: 50vh;
        width: auto;
        height: auto;
    }

    @media (min-width: 960px) {
        img {
            object-fit: contain;
            object-position: center;
            max-height: ${convertPxToRem({ px: 645 })};
            margin-top: ${convertPxToRem({ px: 8 })};
            margin-bottom: ${convertPxToRem({ px: 8 })};
            height: 100%;
        }
    }
    ${({ ratio }) =>
        ratio < 1 &&
        css`
            @media (min-width: 960px) {
                img {
                    margin-top: ${convertPxToRem({ px: 36 })};
                    margin-bottom: ${convertPxToRem({ px: 36 })};
                }
            }
        `}
`;
